module.exports="#define GLSLIFY 1\nvarying vec3 v_normal;\n\nvoid main()\n{\n    gl_FragColor = vec4(v_normal * 0.5 + vec3(0.5), 1.0);\n}\n";